import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function FeaturedSection() {
  const featured = comics.filter((c) => c.tags.includes('独家')).slice(0, 4);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
              独家内容
            </h2>
            <p className="text-sm text-foreground-500">只在韩漫之家才能看到的独家漫画</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 p-4 bg-background-100 rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="w-[80px] h-[110px] flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩漫之家独家正版漫画`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">作者：{comic.author}</p>
                  <p className="text-xs text-foreground-400 mt-1 line-clamp-2">{comic.description}</p>
                </div>
                <div className="flex items-center gap-2 mt-2">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-100 text-accent-700 rounded">
                    独家
                  </span>
                  <span className="text-xs text-foreground-500">{comic.views}次阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}